import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { MarketService } from '@app/core/services/utils/localization/market.service';
import { ClinicFeature } from '@app/shared/utils/enums/feature.enum';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, tap } from 'rxjs/operators';

/**
 * Add the template content to the DOM when market (breeder country) can use the feature
 * Usage:
 *  <div *appMarketGuard="'exampleFeature'"></div>
 */
@Directive({
  selector: '[appMarketGuard]',
  standalone: true,
})
export class MarketGuardDirective implements OnInit, OnDestroy {
  @Input() appMarketGuard: ClinicFeature;

  private sub: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private marketService: MarketService,
  ) {}

  ngOnInit(): void {
    this.sub = this.marketService
      .isEnabled$(this.appMarketGuard)
      .pipe(
        distinctUntilChanged(),
        tap((isEnabled) => {
          this.viewContainer.clear();
          isEnabled && this.viewContainer.createEmbeddedView(this.templateRef);
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
